export const isStaffEmail = (email?: string) => {
  if (!email) return false;

  return email.endsWith('@anara.com') || email.endsWith('@unriddle.ai');
};
